/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1Fincen314FileEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_FINCEN314_FILE_EVENT_ENTITY_NAME = 'ixf.watchlist.v1.Fincen314FileEvent';
export const ixfWatchlistV1Fincen314FileEventEntity = new schema.Entity<IxfWatchlistV1Fincen314FileEvent>(IXF_WATCHLIST_V1_FINCEN314_FILE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfWatchlistV1Fincen314FileEvent) => `${entity.metadata?.eventId}` });

